<template>
  <v-col
    cols="4"
    md="2"
    style="min-width: 10px"
    class="flex-grow-0 flex-shrink-1 text-center"
  >
    <a
      :href="href"
      target="_blank"
      class="d-flex align-center justify-center ma-2"
    >
      <v-img
        :alt="alt"
        :src="image"
        :max-height="scale"
        :max-width="scale"
        contain
      />
    </a>
    <p v-if="caption" class="text-caption">{{ caption }}</p>
  </v-col>
</template>

<script setup lang="ts">
defineProps({
  alt: {
    type: String,
    default: 'logo'
  },
  caption: {
    type: String,
    default: ''
  },
  href: {
    type: String,
    default: undefined
  },
  image: {
    type: String,
    default: ''
  },
  scale: {
    type: String,
    default: '100%'
  }
})
</script>
